import React from "react";
import ReactDOM, { Root } from "react-dom/client";

import { AppWrapper, ContainerProps } from "@/App";
import IFrameService from "@/service/IFrame";
import { queryToJSON } from "@/utils/transform";

export default class ApplicationLoader {
  private readonly container: React.ComponentType<ContainerProps>;
  private readonly root: Root;
  private readonly query: IQuery;

  constructor(container: React.ComponentType<ContainerProps>) {
    const ROOT_NODE: HTMLElement | null = document.getElementById("root");

    if (!ROOT_NODE) {
      throw new Error("Could not find container element with id 'root'.");
    }
    this.root = ReactDOM.createRoot(ROOT_NODE);
    this.container = container;
    const searchParams = queryToJSON(window.location.search.slice(1));
    this.query = {
      id: searchParams.id,
      preview:
        searchParams.preview?.toLowerCase() === "true" ||
        searchParams.preview === "1",
      platform: searchParams.platform,
      locale: searchParams.locale,
      themeName: searchParams.theme,
    };
    this.unmount = this.unmount.bind(this);
  }

  public unmount(): void {
    this.root.unmount();
    IFrameService.destroy();
  }

  public getInteractionId(): string {
    return this.query.id || "";
  }

  public start(): void {
    this.root.render(
      <AppWrapper
        Container={this.container}
        onDestroy={this.unmount}
        query={this.query}
      />
    );
  }
}
